import React from 'react';
import PageContent from 'src/Components/PageContent';
import ProcessingModal from 'src/Pages/Staking/Components/ProcessingModal';
import SuccessModal from 'src/Pages/Staking/Components/SuccessModal';
import ErrorModal from 'src/Pages/Staking/Components/ErrorModal';
import { usePopup } from 'src/Pages/Staking/PopupProvider';
import { formatErrorMessage } from 'src/Pages/Staking/utils';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { AppError } from 'src/redux/types';
import { claimStakingReward, fetchMyStaking } from 'src/redux/actions';
import { formatCurrency } from '@wolffun/system-currency';
import { MenuItem, navigateToProfile } from 'src/utils/navigate';

const ClaimModal = ({
  onClose,
  item
}) => {
  const {
    openMaintenance
  } = usePopup();
  const dispatch = useTypedDispatch();
  const loading = useTypedSelector(state => state.claimStakingReward.loading);
  const invalidated = useTypedSelector(state => state.claimStakingReward.invalidated);
  const error = useTypedSelector(state => state.claimStakingReward.error);

  const renderError = () => /*#__PURE__*/React.createElement(ErrorModal, {
    message: formatErrorMessage(error),
    onClose: onClose
  });

  const renderLoading = () => /*#__PURE__*/React.createElement(ProcessingModal, {
    withTitle: true,
    content: `Claiming ${formatCurrency(item.amount, {
      trimWholeFraction: true,
      withCurrency: true
    })}`,
    onClose: onClose
  });

  const renderContent = () => /*#__PURE__*/React.createElement(SuccessModal, {
    message: `You have claimed ${formatCurrency(item.amount, {
      trimWholeFraction: true,
      withCurrency: true
    })}`,
    subContent: "The rewards will be in THG. Go to your Wallet to claim your rewards to Metamask.",
    buttonTitle: "My Wallet",
    secondaryButtonTitle: "Close",
    onClose: () => {
      onClose();
      dispatch(fetchMyStaking());
    },
    onSubmit: () => navigateToProfile(MenuItem.WALLET)
  });

  React.useEffect(() => {
    const claim = async () => {
      const {
        error
      } = await dispatch(claimStakingReward(item.stakingId));

      if (error === AppError.MAINTENANCE_STAKING) {
        openMaintenance();
        onClose();
        return;
      }
    };

    claim();
  }, []);
  return /*#__PURE__*/React.createElement(PageContent, {
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidated,
    renderContent: renderContent,
    renderError: renderError,
    renderLoading: renderLoading
  });
};

export default ClaimModal;